export default "__VITE_ASSET__380794e7__"